interface LoadingSpinnerProps {
  loadingText: string;
}

export function LoadingSpinner({ loadingText }: LoadingSpinnerProps) {
  return (
    <div
      className="flex flex-col items-center justify-center py-20"
      role="status"
    >
      <div className="relative h-12 w-12">
        <div className="border-soluud-primary/20 absolute inset-0 rounded-full border-4" />
        <div className="border-t-soluud-primary absolute inset-0 animate-spin rounded-full border-4 border-transparent" />
      </div>
      <p className="text-soluud-text-secondary mt-4 text-sm font-medium">
        {loadingText}
      </p>
      <span className="sr-only">Loading</span>
    </div>
  );
}
